import type { RegistryEntry } from '../types';

// Google Veo 3.1 系列 (shared config)
export const googleConfigs: Record<string, RegistryEntry> = {
    ...Object.fromEntries(
        ['veo3.1', 'veo3.1-fast', 'veo3.1-fast-extend'].map(id => [id, {
            options: [
                { key: 'seed', label: 'Seed', type: 'number', min: 10000, max: 99999, step: 1, group: 'advanced' },
                { key: 'waterMark', label: 'WaterMark', type: 'input', group: 'advanced' },
            ],
            toProviderOptions: (ui: Record<string, any>) => ({
                kie_general: {
                    seed: typeof ui.seed === 'number' ? ui.seed : undefined,
                    waterMark: typeof ui.waterMark === 'string' ? ui.waterMark : undefined,
                },
            }),
        } satisfies RegistryEntry])
    ),
    // Gemini Omni Flash 测试版：提示词翻译
    'gemini-omni-flash': {
        options: [
            {
                key: 'translate_to_english',
                label: 'Translate Prompt to English',
                type: 'switch',
                default: false,
                group: 'inline',
            },
        ],
        toProviderOptions: (ui: Record<string, any>) =>
            ({
                translate_to_english: typeof ui.translate_to_english === 'boolean' ? ui.translate_to_english : false,
            } as unknown as Record<string, Record<string, any>>),
    },
    // Gemini Omni Flash API：思考等级 + 提示词翻译
    'gemini-omni-flash-api': {
        options: [
            {
                key: 'thinking_level',
                label: 'Enable Deep Thinking',
                type: 'switch',
                default: false,
                group: 'inline',
            },
            {
                key: 'translate_to_english',
                label: 'Translate Prompt to English',
                type: 'switch',
                default: false,
                group: 'inline',
            },
        ],
        toProviderOptions: (ui: Record<string, any>) =>
            ({
                ...(ui.thinking_level === true ? { thinking_level: 'high' } : {}),
                translate_to_english: typeof ui.translate_to_english === 'boolean' ? ui.translate_to_english : false,
            } as unknown as Record<string, Record<string, any>>),
    },
    // Gemini Omni 1.1 Flash（WaveSpeed）：提示词翻译
    'gemini-omni-1.1-flash': {
        options: [
            {
                key: 'translate_to_english',
                label: 'Translate Prompt to English',
                type: 'switch',
                default: false,
                group: 'inline',
            },
        ],
        toProviderOptions: (ui: Record<string, any>) =>
            ({
                translate_to_english: typeof ui.translate_to_english === 'boolean' ? ui.translate_to_english : false,
            } as unknown as Record<string, Record<string, any>>),
    },
};